<template>
  <div :class="[$style.root, { [$style.lpnh]: pageType === 'lpnh' }]">
    <PerfectScrollbar :class="$style.items">
      <template v-for="(img, index) in imgList" :key="img">
        <template v-if="displayImage(img)">
          <template v-if="img.url">
            <AtomsConsumerLink
              v-if="img.pc_img_url"
              :url="img.url"
              :class="[$style.link, { 'page-parts-pc': img.sp_img_url || displayType === 'pc' }]"
              :style="`width: calc((100% - 1rem * ${pcImgColumn - 1}) / ${pcImgColumn});`"
            >
              <AtomsConsumerImage
                :src="img.pc_img_url ?? ''"
                :alt="img.pc_img_url_caption ?? ''"
                :width="300"
                @click="trackBannerClick('image_slide', img.pc_img_url ?? '', index, img.pc_img_url_caption ?? '')"
              />
            </AtomsConsumerLink>
            <AtomsConsumerLink
              v-if="img.sp_img_url"
              :url="img.url"
              :class="$style.link"
              class="page-parts-sp"
              :style="`width: calc((100% - 1rem * ${spImgColumn - 1}) / ${spImgColumn});`"
            >
              <AtomsConsumerImage
                :src="img.sp_img_url"
                :alt="img.sp_img_url_caption ?? ''"
                :width="windowWidth > 344 ? 344 : windowWidth"
                @click="trackBannerClick('image_slide', img.sp_img_url ?? '', index, img.sp_img_url_caption ?? '')"
              />
            </AtomsConsumerLink>
          </template>
          <template v-else>
            <AtomsConsumerImage
              v-if="img.pc_img_url"
              :src="img.pc_img_url ?? ''"
              :alt="img.pc_img_url_caption ?? ''"
              :class="{ 'page-parts-pc': img.sp_img_url || displayType === 'pc' }"
              :style="`width: calc((100% - 1rem * ${pcImgColumn - 1}) / ${pcImgColumn});`"
              :width="300"
            />
            <AtomsConsumerImage
              v-if="img.sp_img_url"
              :src="img.sp_img_url"
              :alt="img.sp_img_url_caption ?? ''"
              class="page-parts-sp"
              :style="`width: calc((100% - 1rem * ${spImgColumn - 1}) / ${spImgColumn});`"
              :width="windowWidth > 344 ? 344 : windowWidth"
            />
          </template>
        </template>
      </template>
    </PerfectScrollbar>
  </div>
</template>

<script setup lang="ts">
import { DisplayType } from "@tential/ec-gql-schema/master/pageParts"
import { PerfectScrollbar } from "vue3-perfect-scrollbar"
import { PagePartsFragmentFragment } from "~/types/pageParts"

type Props = {
  imgList: PagePartsFragmentFragment["list"]
  pcImgColumn?: number
  spImgColumn?: number
  displayType?: DisplayType
  pageType?: string
}

withDefaults(defineProps<Props>(), {
  pcImgColumn: 4,
  spImgColumn: 2,
  displayType: "all",
  pageType: "",
})

const { width: windowWidth } = useWindowSize()
const minScreenMd = computed(() => windowWidth.value >= 768)

const { trackBannerClick } = useGtagEvent()

const displayImage = (img: any): boolean => {
  if (!minScreenMd.value) return !!img.sp_img_url
  return !!img.pc_img_url
}
</script>

<style module lang="scss">
.root {
  @include container-lg;
  .items {
    display: flex;
    width: 100%;
    gap: 1rem;
    overflow-x: scroll;
    padding-bottom: 1rem;

    a {
      flex-shrink: 0;
      height: 100%;
      img {
        height: 100%;
        width: 100%;
      }
    }

    img {
      flex-shrink: 0;
      height: 100%;
      border-radius: 0.375rem;
    }

    &:first-child {
      padding-left: 1rem;
    }

    &:last-child {
      padding-right: 1rem;
    }
  }
  &.lpnh {
    @include full-container-lg;
  }
}
</style>
